import {
  Pagination,
  PaginationDisplayedItemCount,
} from '@one-thd/sui-atomic-components';
import React from 'react';
import { usePurchaseHistoryContext } from '../../../hooks/useContexts';
import { getNumPages, getWindow } from '../../../utils/general';
import { ILDRequest } from '../../../models/purchase-history';

export const ODTablePagination = () => {
  const { localDeliveryData, lDRequest, setLDRequest } =
    usePurchaseHistoryContext();

  const totalNumberOfODOrders = localDeliveryData?.orderCount ?? 0;

  return (
    <div
      className="sui-grow"
      data-testid="pagination-compact-and-item-count-local-delivery"
    >
      <div className="sui-relative sui-flex sui-items-center sui-gap-4 sui-flex-col-reverse sm:sui-flex-row sm:sui-gap-0">
        <PaginationDisplayedItemCount
          page={lDRequest.pageNumber}
          itemsPerPage={20}
          items={totalNumberOfODOrders}
        />
        <Pagination
          count={getNumPages(20, totalNumberOfODOrders)}
          page={lDRequest.pageNumber}
          onChange={(_event, selectedPage: number) => {
            setLDRequest((prevState: ILDRequest) => {
              return {
                ...prevState,
                pageNumber: selectedPage,
              };
            });
            getWindow()?.scrollTo({ top: 0 });
          }}
          siblingCount={1}
          boundaryCount={1}
          showFirstButton
          showLastButton
        />
      </div>
    </div>
  );
};
